import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import { Box, Typography, IconButton, Grid, CardMedia, CardContent } from '@mui/material';
import { motion } from "framer-motion";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
}));

export default function V2InstructorCard(props) {
    const { isSmallScreen, image, name, description, title, id} = props;

    return (
        <Grid item xs={12} sm={6} md={4} key={name}>
            <Card
                component={motion.div}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: id * 0.2 }}
                sx={{
                    overflow: "hidden",
                    height: "600px",
                    background: "transparent",
                    boxShadow: "none",
                    border: "none",
                    padding: "0 1.5rem"
                }}
            >
                <Box sx={{ position: "relative" }}>
                    <CardMedia
                        component="img"
                        image={image}
                        alt={name}
                        sx={{
                            borderRadius: "22px 22px 22px 0",
                            height: 280,
                            objectFit: "cover",
                        }}
                    />
                    <div style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        backgroundColor: "white",
                        padding: "10px",
                        borderRadius: "0 15px 0 0",
                    }}>
                        <IconButton
                            aria-label={`Learn more about ${name}`}
                            sx={{
                                backgroundColor: "#000",
                                color: "#fff",
                                borderRadius: "50%",
                                width: 40,
                                height: 40,
                                "&:hover": { backgroundColor: "#111" },
                            }}
                        >
                            <ArrowOutwardIcon />
                        </IconButton>
                    </div>
                </Box>


                <CardContent sx={{ textAlign: "left", px: 2, py: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, fontFamily: "Poppins, sans-serif" }}>
                        {name}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            color: "#8b43ff",
                            fontWeight: 600,
                            mb: 1,
                            fontSize: "1rem",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#555",
                            lineHeight: 1.6,
                            fontSize: "14px",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        {description}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    );
}